import { Suspense } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import "../src/utils/axios";
import Loader from "./components/Loader";
import Socket from "./components/Socket";
import { useGeoRedirect } from "./hooks/useGeoRedirect";
import { OldBaseRoute } from "./routes/RegexRoute";
import lazyWithRetry from "./utils/lazy";
const RefreshJwt = lazyWithRetry(() => import("./components/RefreshJwt"));
const CartMain = lazyWithRetry(() => import("./components/cart/CartMain"));
const ScrollToTop = lazyWithRetry(() => import("./components/ScrollToTop"));
const Chatbot = lazyWithRetry(() => import("./components/chatbot/Chatbot"));
const GlobalLoader = lazyWithRetry(() => import("./components/GlobalLoader"));
const ProductQuickLookPage = lazyWithRetry(() => import("./pages/ProductQuickLookPage"));
const GlobalUserRouteGuard = lazyWithRetry(() => import("./components/GlobalUserRouteGuard"));

const Footer = lazyWithRetry(() => import("./components/Footer"));
const ProRoutes = lazyWithRetry(() => import("./routes/ProRoutes"));
const WebRoutes = lazyWithRetry(() => import("./routes/WebRoutes"));
const Header = lazyWithRetry(() => import("./components_web/Header"));
const AdminRoutes = lazyWithRetry(() => import("./routes/AdminRoutes"));
const DaysOfGlyMed = lazyWithRetry(() => import("./pages/DaysOfGlyMed"));
const RetailRoutes = lazyWithRetry(() => import("./routes/RetailRoutes"));
const SchoolRoutes = lazyWithRetry(() => import("./routes/SchoolRoutes"));
const PageNotFound = lazyWithRetry(() => import("./components/PageNotFound"));
const LaunchStorePage = lazyWithRetry(() => import("./pages/LaunchStorePage"));
const HotjarHeatMap = lazyWithRetry(() => import("./components/HotjarHeatMap"));
const ImpersonationPage = lazyWithRetry(() => import("./pages/ImpersonationPage"));
const RecommendationPage = lazyWithRetry(() => import("./pages/RecommendationPage"));
const ProductDetails = lazyWithRetry(() => import("./components/ProductDetails/ProductDetails"));
const RecommendationByAdminPage = lazyWithRetry(() => import("./pages/RecommendationByAdminPage"));
const AcknowledgeREGENRewards = lazyWithRetry(() => import("./components/AcknowledgeREGENRewards"));
const AcceptTermsAndCondition = lazyWithRetry(() => import("./components/AcceptTermsAndCondition"));
const RegenRewardReferralsPage = lazyWithRetry(() => import("./pages_web/RegenRewardReferralsPage"));

function App() {
  const location = useLocation();
  const { backgroundLocation } = location.state || {};
  useGeoRedirect();
  return (
    <Suspense fallback={<Loader style={{ minHeight: "100vh" }} />}>
      <div className="App">
        <Header />
        <Routes location={backgroundLocation || location}>
          {/* ==Old Route Redirect== */}
          {OldBaseRoute()}
          {/* ======ENd======= */}

          <Route path="*" element={<WebRoutes />} />
          <Route path="b2b/*" element={
            <GlobalUserRouteGuard>
              <ProRoutes />
            </GlobalUserRouteGuard>
          } />
          <Route path="retail/*" element={
            <GlobalUserRouteGuard>
              <RetailRoutes />
            </GlobalUserRouteGuard>
          } />
          <Route path="school/*" element={<SchoolRoutes />} />
          <Route path="admin/*" element={<AdminRoutes />} />
          <Route path="products/:productId" element={<ProductDetails />} />
          <Route path="cart" element={
            <GlobalUserRouteGuard>
              <CartMain />
            </GlobalUserRouteGuard>
          } />
          <Route
            path="reward-referral"
            element={
              <GlobalUserRouteGuard>
                <RegenRewardReferralsPage />
              </GlobalUserRouteGuard>
            }
          />
          <Route path="launch/:storeLabel" element={<LaunchStorePage />} />
          <Route path="store/:storeLabel" element={<LaunchStorePage />} />
          <Route path="impersonate/:id" element={<ImpersonationPage />} />
          <Route
            path="recommendations/:bundleToken/:accountId"
            element={<RecommendationPage />}
          />
          <Route
            path="bundle/:bundleToken"
            element={<RecommendationByAdminPage />}
          />
          <Route path="12-days-of-glymed" element={<DaysOfGlyMed />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
        {backgroundLocation ? (
          <Routes>
            <Route path="products/:sku" element={<ProductQuickLookPage />} />
            <Route path="cart" element={<CartMain />} />
          </Routes>
        ) : null}
        <Chatbot />
        <Footer />
        <RefreshJwt />
        <GlobalLoader />
        <ScrollToTop />
        <AcknowledgeREGENRewards />
        <AcceptTermsAndCondition />
        <Socket />
        {process.env.REACT_APP_APP_MODE === "production" && <HotjarHeatMap />}
      </div>
    </Suspense>
  );
}

export default App;
